(function () {
    'use strict';

    var weekCellControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/week-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            obj: "<",
            layout: "<",
            settings: "<",
            width: "<",
            height: "<",
            isMin: "<",
            index: "<",
            weekConfig: "<"
        },

        controller: ['$scope', 'FontManagement','$timeout', function ($scope, FontManagement,$timeout) {
            var vm = this;
            vm.data = {
                width: 100,
                height: 50,
                items: []
            };

            vm.$onInit = function() {
                // var settings = vm.settings || {};
                // constructCell(vm.layout, settings, vm.obj);
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if (data.layout && data.layout.currentValue) {
                    vm.layout = data.layout.currentValue;
                }
                if (data.settings && data.settings.currentValue) {
                    vm.settings = data.settings.currentValue;
                }
                if (data.obj && data.obj.currentValue) {
                    vm.obj = data.obj.currentValue;
                }
                if (data.weekConfig && data.weekConfig.currentValue) {
                    vm.weekConfig = data.weekConfig.currentValue;
                }
                constructCell(vm.layout, vm.settings, vm.obj);
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                };
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                var cw = layout.width || 100;
                var ch = layout.height || 50;
                var width = vm.width || 100;
                var height = vm.height || 50;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: angular.copy(width),
                        height: angular.copy(height)
                    },
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                var lineW = 0;
                if (settings && settings.items && settings.items.length) {
                    var border = settings.border;
                    if (settings.border && settings.border.lineType && settings.border.lineWidth && border.color) {
                        lineW = (border.lineWidth)*2;
                        vm.data.styles['border'] = (border.lineWidth) + 'px ' + border.lineType + " "  + border.color;
                        if(vm.weekConfig){
                            if(vm.weekConfig.removeBorderOverlap){
                                if(vm.index > 0){
                                    lineW = border.lineWidth;
                                    vm.data.styles['border-left'] = 0 + 'px ' + border.lineType + " "  + border.color;
                                }
                            }
                            if(vm.weekConfig.removeBorderBottom){
                                vm.data.styles['border-bottom'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                        }
                    }
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    width = width - lineW;
                    height = height - lineW;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        var ci1 = layout.items[i];
                        if (ci.type == "image" || ci.type == 'userimage') {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };
                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: Number.parseInt(ci.textSize) * width / cw,
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid,
                                backgroundColor: ci.backgroundColor
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFont({
                                    fontuuid: element.textFontUuid
                                },FontManagement);
                            }
                            if (item.textSize) {
                                element.textSize = Number.parseInt(item.textSize) * width / cw;
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }
                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj || vm.obj, ci.type, ci1.format) || {};
                            var text = {
                                type: ci.type,
                                format: ci1.format,
                                value: data.value || ci.value || ci.sample || '一',
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "week",
                        format: "$cnWeek",
                        value: "星期日",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#000000',
                        textWeight: 600,
                        x: 5 * width / 100,
                        y: 10 * height / 50,
                        w: 90 * width / 100,
                        h: 30  * height / 50,
                        fixedTo: ''
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            }
            $scope.itemValue = function (item) {
                if(item&&item.value){
                    return item.value
                }
            }
        }]
    };
    angular.module('platformApp')
        .component('weekCell', weekCellControl);

})();
